import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteTvBrandDocument } from './delete.generated';

export const useDeleteTVBrand = (options: ApiOptions<typeof DeleteTvBrandDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteTvBrandDocument, {
    ...useNotifications(DeleteTvBrandDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.tv_brands.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteTvBrand?.tvBrand == null) return;
      cache.evict({ id: cache.identify(data.deleteTvBrand.tvBrand) });
    },

    ...options,
  });
};
